<script setup lang="ts">

import { useRouter } from 'vue-router';
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';

const {
  bankAccessId,
  bankAccountId,
  transactionId
} = defineProps<{
  bankAccessId: string,
  bankAccountId: string,
  transactionId: string
}>();

const router = useRouter();

async function onGoBack(event: CustomEvent) {
  event.preventDefault();
  await router.push(`/banking/${bankAccessId}/account/${bankAccountId}`);
}
</script>

<template>
  <BankingWrapper v-slot="{ token, onEmitError }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <!-- eslint-disable vue/attribute-hyphenation -->
    <ba-account-transaction-detail
      :token="token"
      :bankAccessId="bankAccessId"
      :bankAccountId="bankAccountId"
      :transactionId="transactionId"
      @emitError="(e) => onEmitError(e, 'ba-account-transaction-detail')"
      @goBack="onGoBack"
    />
  </BankingWrapper>
</template>
